import { protectAdminRoleLiterals } from './protect-admin-role-literals.js'
import { protectExistingNamespaceLiterals } from './protect-existing-namespace-literals.js'
import { protectExternalModuleSpecifiers } from './protect-external-module-specifiers.js'
import { replaceAdminCamelToken } from './replace-admin-camel-token.js'
import { replaceAdminDashToken } from './replace-admin-dash-token.js'
import { replaceAdminPascalToken } from './replace-admin-pascal-token.js'
import { replaceAdminScreamingToken } from './replace-admin-screaming-token.js'
import { resolveAdminNamespace } from './resolve-admin-namespace.js'

export function applyAdminNamespaceToContent(content: string, namespaceValue: string): string {
  const namespace = resolveAdminNamespace(namespaceValue)
  const { content: externalSafeContent, restore: restoreExternalModules } =
    protectExternalModuleSpecifiers(content)
  const { content: protectedContent, restore } = protectAdminRoleLiterals(externalSafeContent)

  const canonicalContent = protectedContent
    .replaceAll('MediaListParams', `${namespace.pascal}MediaQuery`)
    .replaceAll('MediaListResult', `${namespace.pascal}MediaPage`)
    .replaceAll(
      `${namespace.pascal}MediaQuery, ${namespace.pascal}MediaPage`,
      `${namespace.pascal}MediaPage, ${namespace.pascal}MediaQuery`
    )
    .replaceAll('UserData', 'User')
    .replaceAll('UsersResponse', 'UsersPage')
    .replaceAll('SettingData', 'Setting')
    .replaceAll('UpsertSettingInput', 'SettingUpsertInput')
    .replaceAll('UpsertSettingResult', 'SettingUpsertResult')
    .replace(
      /import\s+\{\s*admin\s*\}\s+from\s+(['"])@admin\/utils\/app\/admin\1/g,
      (_match, quote: string) =>
        `import { ${namespace.camel} } from ${quote}${namespace.alias}/utils/app/${namespace.camel}${quote}`
    )
    .replace(/\badmin(?=\.name\b)/g, namespace.camel)
    .replaceAll('@admin/auth/middleware', `${namespace.alias}/auth/session`)
    .replaceAll('@admin/auth/auth', `${namespace.alias}/auth/server`)
    .replaceAll('@admin/auth/client', `${namespace.alias}/auth/client`)
    .replace(/@admin\/auth(?=['"`\s)]|$)/g, `${namespace.alias}/auth/server`)
    .replace(/(\bimport\b[^\n]*\bfrom\s+)'\.\/auth'/g, "$1'./server'")
    .replace(/@admin(?=\/|$)/g, namespace.alias)
    .replace(/\/api\/admin(?=\/|['"`]|$)/g, namespace.apiPath)
    .replace(/(^|\/)admin(?=\/|['"`]|$)/g, `$1${namespace.segment}`)
    .replaceAll('(admin)', namespace.routeGroup)

  const protectedNamespace = protectExistingNamespaceLiterals(canonicalContent, namespace)
  const namespacedContent = replaceAdminCamelToken(
    replaceAdminPascalToken(
      replaceAdminScreamingToken(
        replaceAdminDashToken(protectedNamespace.value, namespace),
        namespace
      ),
      namespace
    ),
    namespace
  )

  return restoreExternalModules(restore(protectedNamespace.restore(namespacedContent)))
}
